var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import './Typography.css';
const Typography = (_a) => {
    var { className = '', children, fontSize = '', fontFamily = '', fontWeight = '', fontStyle, color = '', rtl = false, textTransform, alignLeft = 'left', alignRight = 'right', height, width, onClick, id } = _a, props = __rest(_a, ["className", "children", "fontSize", "fontFamily", "fontWeight", "fontStyle", "color", "rtl", "textTransform", "alignLeft", "alignRight", "height", "width", "onClick", "id"]);
    const textAlign = rtl ? alignRight : alignLeft;
    return (_jsx("div", Object.assign({}, props, { id: id, className: `typography ${className}`, onClick: onClick, style: {
            fontSize,
            fontFamily,
            fontWeight,
            fontStyle,
            color,
            textAlign,
            textTransform,
            height,
            width
        } }, { children: children }), void 0));
};
export default Typography;
